import { observer } from 'mobx-react';
import Row from './Row';
import { MulticheckStore } from '../../../../../Multicheck/Store';
import { InvitationResource } from '../Store/Types';
import ModalStore from '../../../../Modal/Store';
import InvitationStore from '../Store/InvitationStore';

interface Props {
  invitationStore: InvitationStore;
  invitations: InvitationResource[];
  multicheckStore: MulticheckStore<InvitationResource>;
  modalStore: ModalStore;
}

function Body({ invitationStore, invitations, multicheckStore, modalStore }: Props) {
  return (
    <tbody className="divide-y divide-gray-200 bg-white">
      {invitations.map((resource) => (
        <Row
          store={invitationStore}
          resource={resource}
          key={resource.payload.id}
          multicheckStore={multicheckStore}
          modalStore={modalStore}
        />
      ))}
    </tbody>
  );
}

export default observer(Body);
